// questions.js
const questions = {
  section1: {
    title: "Personal Krishna Consciousness",
    questions: [
      { id: 1, question: "What made you take up Krishna Consciousness?" },
      { id: 2, question: "When was it?" },
      { id: 3, question: "Where was it?" },
      { id: 4, question: "Who was involved?" },
      {
        id: 5,
        question:
          "How has this decision to take up Krishna Consciousness affected you as a person?",
      },
      { id: 6, question: "How has this decision affected your activities?" },
      {
        id: 7,
        question: "How has this decision affected your goals and ambitions?",
      },
      {
        id: 8,
        question:
          "[If you were born to practicing devotees] Have you accepted Krishna consciousness in your heart? If so, since when? Was anyone involved in your full-fledged acceptance of Krishna consciousness? Who was it? ",
      },
      {
        id: 9,
        question: "How many rounds do you chant? If it is sixteen, since when?",
      },
      {
        id: 10,
        question:
          "Do you read Srila Prabhupada's books every day? If yes, how many hours?",
      },
      { id: 11, question: "Which books of Srila Prabhupada have you read?" },
      {
        id: 12,
        question: "Which books of Srila Prabhupada are you currently reading?",
      },
      {
        id: 13,
        question:
          "How many biographies of Srila Prabhupada have you read? Which ones?",
      },
      {
        id: 14,
        question:
          "Have you done Bhakti Sastri, Bhakti Vaibhav or any other such courses in ISKCON. If yes, which ones, and from where?",
      },
      {
        id: 15,
        question:
          "Are you more inclined to hear the philosophy of Krishna Consciousness or pastimes of the Supreme Lord or both equally?",
      },
      {
        id: 16,
        question:
          "If you are initiated or aspiring from a spiritual master in ISKCON, what inspired you to accept him as your spiritual master/prospective spiritual master?",
      },
      {
        id: 17,
        question:
          "Who are your role models in Krishna Consciousness and what inspires you about them?",
      },
      {
        id: 18,
        question:
          "Krishna Consciousness is generally practiced under the guidance of experienced devotees. Have you had that opportunity? If yes, who was/were that/those devotee/s until now in your life?",
      },
      {
        id: 19,
        question:
          "Have you ever lived as a brahmacari/ brahmacarini in an ISKCON temple? If yes, how many years and where?",
      },
      {
        id: 20,
        question:
          "What do you think is your relationship with Srila Prabhupada?",
      },
      {
        id: 21,
        question: "What is your relationship with your Diksa and Siksa Gurus?",
      },
      {
        id: 22,
        question:
          "What is your relationship with your counsellor(s) and Temple President?",
      },
      {
        id: 23,
        question:
          "Is there a hierarchical sequence in which you follow the above spiritual authorities? If yes, specify the hierarchy. If not, how do you try to balance the instructions from the above different spiritual authorities?",
      },
      {
        id: 24,
        question:
          "In Krishna Consciousness, we are taught that we should discriminate between right and wrong. We are also taught not to criticise. What do you think is the difference, if any, between such discrimination and criticism? How will you practice these things in your life?",
      },
      {
        id: 25,
        question:
          "What will you do if your counsellor(s) and/or Temple President and/or Guru(s) differ from Prabhupada?",
      },
      {
        id: 26,
        question:
          "On some topics like fall of the jiva, Srila Prabhupada has given apparently contradictory opinions. How do you understand Prabhupada's apparently contradictory statements?",
      },
      {
        id: 27,
        question:
          "Which of the following represents your understanding of Srila Prabhupada's position?",
        options: [
          "Prabhupada is always correct",
          "Prabhupada is fully perfect when he presents spiritual teachings but when he talks about material subjects, he may be correct or incorrect. He came to give us spiritual teachings. So it does not matter even when he is not always correct about material subjects. ",
        ],
      },
      {
        id: 28,
        question: "How would you describe your sadhana?",
        options: [
          "Strict/Very good",
          "Good",
          "Reasonably good",
          "Average",
          "Struggling",
          "Poor",
        ],
      },
      {
        id: 29,
        question:
          "Do you have any difficulty in following the four regulative principles? (Difficulty does not necessarily mean breaking the principles)",
        options: ["Yes", "No", "Sometimes"],
      },
      {
        id: 30,
        question:
          "Do you sometimes break the regulative principles? If yes, which ones and why?",
      },
      {
        id: 31,
        question: "Do you have difficulties rising early? What's the reason?",
        options: [
          "My office work hours",
          "I find it more productive to stay up late at night",
          "Just due to lack of discipline",
          "Combination of some or all of the above",
          "None of the above.",
        ],
      },
      {
        id: 32,
        question:
          "What services do you render at/for the local temple currently? Are you looking for more engagement there?",
      },
      {
        id: 33,
        question:
          "What services do you render online currently? Are you looking for more online engagement?",
      },
      {
        id: 34,
        question: "What sort of preaching have you performed?",
        options: [
          "Book distribution",
          "Bhakti Vriksha/Namhatta/Home Programs",
          "Paraphernalia distribution",
          "Festival/college preaching",
          "Others",
          "I am not a preacher",
        ],
      },
      { id: 35, question: "Do you like to take up a leadership position?" },
      { id: 36, question: "Do you like to give classes?" },
      { id: 37, question: "Do you like to lead kirtans" },
      {
        id: 38,
        question:
          "Select which services you like and order them according to your preference from highest to lowest.If one or more services that you like are not mentioned in the list, please choose 'Others' and specify.",
      },
      {
        id: 39,
        question: "Service preference list",
        options: [
          "Pujari",
          "Gardening",
          "Tulasi worship",
          "Making flower vases",
          "Mechanics",
          "Painting",
          "Purchasing",
          "Maintenance",
          "Jewelry making",
          "Using computers",
          "Cow protection",
          "Teaching",
          "Sankirtan",
          "Sewing",
          "Administration",
          "Childcare",
          "Farming",
          "Business",
          "Translating",
          "Researching",
          "Construction",
          "Electronics",
          "Medical",
          "Cooking",
          "Theatre",
          "Carpentry",
          "Designing outfits",
          "Restaurant",
          "Secretarial",
          "Writing",
          "Baby-sitting",
          "Deity worship",
          "Participating in Kirtan",
          "Transcription",
          "Editing",
          "Giving classes",
          "Leading Kirtan",
          "Leadership position",
          "Other: (Please specify)",
        ],
      },
      {
        id: 40,
        question: "Do you prefer to wear traditional Vaishnava dress?",
      },
      {
        id: 41,
        question:
          "What is your opinion about the following dresses while visiting the temple?",
        subQuestions: ["Yoga pants", "Gopi dress", "Shalwar kameez"],
      },
      {
        id: 42,
        question:
          "What is your opinion about wearing tilak all the time in the following places?",
        subQuestions: ["Work", "Home", "Temple"],
      },
      {
        id: 43,
        question:
          "Throughout the final chapters of the Bhagavad-gita, Lord Krishna gives symptoms of the mode of goodness. List all of them. (You can refer to the Bhagavad-gita if you wish) On a scale of 0-10, rate where you think you stand at this point in your life in regard to each symptom.",
      },
      {
        id: 44,
        question:
          "Krishna instructs us in the Bhagavad-gita to tolerate happiness and distress. On a scale of 0-10 what do you think is your ability to tolerate distress?",
      },
      {
        id: 45,
        question:
          "What is meant by tolerating happiness? Please give some examples.",
      },
      {
        id: 46,
        question:
          "What are the three best experiences and three difficult experiences you have had in Krishna Consciousness?",
      },
      {
        id: 47,
        question:
          "Were there some circumstances in which you had to give up your spiritual practices for some time? What were they? How did you resume?",
      },
      {
        id: 48,
        question:
          "How much do you think astrology/past karma influences the life of a devotee?",
      },
      {
        id: 49,
        question:
          "If you could ask Srila Prabhupada, your spiritual master(s) and/or Krishna to help you with an area of your life, which area would it be? How long has this been a concern?",
      },
    ],
  },
  section2: {
    title: "Personality and Preferences",
    questions: [
      {
        id: 1,
        question:
          "Who are your role models in the larger world (presently alive or those who have passed away) outside the society of devotees? What is it about them that inspires you? In what way have they influenced your life?",
      },
      {
        id: 2,
        question:
          "What television programs, movies and books have made an impact on your life and in what way?",
      },
      {
        id: 3,
        question:
          "Choose which option from the pairs below apply to your personality type.",
        options: [
          "Generally extrovert",
          "Generally introvert",
          "Generally risk-taking",
          "Generally playing safe",
          "I do whatever is needed whether it is risk taking or playing safe",
          "Generally likes individual initiatives",
          "Generally likes group initiatives",
          "Generally decisive",
          "Generally fluid",
          "Generally confrontational",
          "Generally conciliatory",
          "Generally serious",
          "Generally jovial",
          "Generally thoughtful",
          "Generally easy going",
          "Generally the same",
          "Generally moody",
          "Generally likes a steady and rigid approach in following a schedule",
          "Generally likes a spontaneous and flexible approach",
        ],
      },
      {
        id: 4,
        question: "Are you materially ambitious?",
      },
      {
        id: 5,
        question:
          "What are the various jobs you've held, and for how long? What did you like and dislike about each one?",
      },
      {
        id: 6,
        question: "What are your financial responsibilities and goals?",
      },
      {
        id: 7,
        question:
          "How capable are you in budgeting, balancing check books, shopping patterns etc.",
      },
      {
        id: 8,
        question: "How stressful are these things to you?",
      },
      {
        id: 9,
        question: "What debts do you have at this time?",
      },
      {
        id: 10,
        question:
          "What has been the greatest amount of debt you've experienced?",
      },
      {
        id: 11,
        question: "Have you ever filed for bankruptcy?",
      },
      {
        id: 12,
        question:
          "To what degree are you a saver or a spender when it comes to money?",
        options: [
          "Spender",
          "Primarily Spender",
          "Primarily Saver",
          "Equally Spender and Saver",
          "Saver",
        ],
      },
      {
        id: 13,
        question:
          "If you inherited a large sum of money and could afford to live anywhere in the world, where would it be?",
      },
      {
        id: 14,
        question:
          "In addition, what would you love to do that you can't do now?",
      },
      {
        id: 15,
        question: "How would you use the money?",
      },
      {
        id: 16,
        question: "Would you share your wealth with Krishna? If so, how much?",
      },
      {
        id: 17,
        question: "To which project?",
      },
      {
        id: 18,
        question:
          "What are five habits you're glad you have and five you wish you didn't?",
      },
      {
        id: 19,
        question:
          "When you enter a place where the door generally remains closed and is expected to remain closed, do you close the door after entering?",
        options: [
          "Sometimes",
          "Always",
          "Never thought of this before.",
          "I don't close because my mind is absorbed in the purpose for which I entered the place",
          "I don't close only when there is a lone member of the opposite sex in the place. Otherwise, I always do.",
        ],
      },
      {
        id: 20,
        question:
          "What are the areas of your life that you are presently in control?",
      },
      {
        id: 21,
        question: "What are the areas in your life you would like to control?",
      },
      {
        id: 22,
        question: "How would you rate yourself in punctuality?",
        options: [
          "Always punctual",
          "Generally punctual",
          "I find that difficult",
        ],
      },
      {
        id: 23,
        question: "Do you like to be neatly dressed? Or whatever works?",
      },
      {
        id: 24,
        question: "Do you like an organised home? Or whatever works?",
      },
      {
        id: 25,
        question:
          "Are you active on social media? If so, how does it help you and/or others?",
      },
      {
        id: 26,
        question:
          "How would you rate your friendships with those of the same sex?",
        options: [
          "Easy—it's a snap",
          "Whatever—I can take them or leave them",
          "They're hard work but worthwhile",
          "Discouraging—they let you down",
          "Not sure if I've had a deep friendship",
        ],
      },
      {
        id: 27,
        question:
          "What is your opinion about “good friends” relationships between members of the opposite sex?",
      },
      {
        id: 28,
        question:
          "What is your opinion about “just friends” relationships between members of the opposite sex?",
      },
      {
        id: 29,
        question:
          "What is your opinion about Facebook friends of the opposite sex?",
      },
      {
        id: 30,
        question:
          "Could you describe the people in your life whose personality types are the easiest to get along with and those people whose personality types are the most difficult?",
      },
      {
        id: 31,
        question:
          "What makes it easy for you to be open, and what makes it difficult?",
      },
      {
        id: 32,
        question: "If you open up, do you open up to many people?",
      },
      {
        id: 33,
        question:
          "Of all the emotions we experience in life, what are the easiest ones for you to express and what are the most difficult?",
      },
      {
        id: 34,
        question:
          "How do you take it when devotees or non-devotees point out an actual fault in you and advise you?",
        options: [
          "Drop the issue without saying anything",
          "Apologise and correct yourself",
          "Hold firm just to make a point",
        ],
      },
      {
        id: 35,
        question:
          "How comfortable are you with confrontation or conflict? During a conflict, a person either yields, withdraws, compromises, wins, or resolves mutually. Which of these or a combination of these tends to be your style?",
      },
      {
        id: 36,
        question:
          "What creates the greatest stress and frustration in your life?",
      },
      {
        id: 37,
        question: "Describe how you handle stress and frustration.",
      },
      {
        id: 38,
        question:
          "What have you learned in the following situations in your life?",
        options: [
          "Defeat/Failure",
          "Pain",
          "Waiting",
          "Not having enough money",
          "Facing disappointment (from friends/family members/others)",
          "Facing criticism",
        ],
      },
      {
        id: 39,
        question:
          "What was the lowest point or most difficult time in your life, and how did you handle it? (This can be pre-Krishna Consciousness or post-Krishna Consciousness.)",
      },
      {
        id: 40,
        question:
          "Can you think of any loss in your life that you've never fully recovered from?",
      },
      {
        id: 41,
        question:
          "Who are the people in your life you've needed to forgive, and how did you accomplish this? Are there people you still need to forgive? What do you need to forgive them for?",
      },
      {
        id: 42,
        question:
          "On a scale of 0-10, how much do you value humour in your life?",
      },
      {
        id: 43,
        question: "Do you watch television?",
        options: [
          "Often",
          "Occasionally",
          "Never",
          "Only news",
          "Some items I prefer (Sports, Nat Geo etc).",
        ],
      },
      {
        id: 44,
        question:
          "Do you watch Hollywood, Bollywood or other movies from the secular world?",
        options: [
          "Yes",
          "No",
          "Only science fiction",
          "Some movies that I prefer",
        ],
      },
      {
        id: 45,
        question: "What music style do you like?",
        options: [
          "Contemporary",
          "Western Classical",
          "Traditional Vaishnava",
          "Some combination of the above",
          "All",
          "I’m not into music",
        ],
      },
      {
        id: 46,
        question:
          "Do you hear Rock, Pop, Jazz, Instrumental or other compositions of artists from the secular world?",
        options: ["Yes", "No", "Sometimes"],
      },
      {
        id: 47,
        question: "Do you hear Indian Film songs?",
        options: ["Yes", "No", "Sometimes"],
      },
      {
        id: 48,
        question:
          "Do you like to visit restaurants outside the society of devotees which sell vegetarian food that do not contain onion and garlic?",
        options: ["Yes", "No", "Sometimes"],
      },
      {
        id: 49,
        question:
          "Do you like to snack on vegetarian chips, biscuits, energy bars, ice creams or other items made by shops/companies not connected with devotees?",
        options: ["Yes", "No", "Sometimes"],
      },
      {
        id: 50,
        question: "Do you like to eat Chocolates?",
        options: ["Yes", "No", "Sometimes"],
      },
      {
        id: 51,
        question: "Do you read anything other than devotional literature?",
        options: [
          "Yes",
          "No",
          "Only science fiction",
          "Only self-help books",
          "Only books relevant to my field of work",
          "Some books that I prefer.",
        ],
      },
      {
        id: 52,
        question: "What kind of sports and hobbies do you like?",
        description:
          "Choose those you like from the list below. If not listed, choose 'Others' and specify.",
        options: [
          "Water sports",
          "Writing",
          "Football/Soccer",
          "Book collection",
          "Aerobics",
          "Tennis",
          "Talking",
          "Stamp collection",
          "Chess",
          "Ham radio",
          "Boating",
          "Music collection",
          "Reading",
          "Crafts",
          "Volleyball",
          "Indoor games",
          "Walking",
          "Playing instruments",
          "Astrology",
          "Badminton",
          "Painting",
          "Horseback riding",
          "Hatha-yoga",
          "Computer games",
          "Cricket",
          "Esoteric sciences",
          "Singing",
          "Gardening",
          "Flying airplane",
          "Dancing",
          "Others",
        ],
      },
      {
        id: 53,
        question:
          "How much time during a week do you spend on these sports and hobbies? Would this change or stay the same if you were married?",
      },
      {
        id: 54,
        question:
          "What are your beliefs about pornography, and to what degree did you pursue it in your life? How recently?",
      },
      {
        id: 55,
        question:
          "What are your beliefs about erotic novels, and to what degree did you pursue it in your life? How recently?",
      },
      {
        id: 56,
        question: "Have you travelled often? Do you like to travel?",
      },
      {
        id: 57,
        question: "What is your concept of a holiday? Why?",
      },
      {
        id: 58,
        question:
          "Do you like living in the countryside more than in the city?",
      },
      {
        id: 59,
        question: "What are your feelings about eating healthy?",
      },
      {
        id: 60,
        question: "What kind of food do you like?",
        options: ["Simple", "Opulent", "Mixed"],
      },
      {
        id: 61,
        question: "What cuisines do you enjoy?",
      },
      {
        id: 62,
        question: "Do you find it difficult to fast?",
      },
      {
        id: 63,
        question: "How is your health in general?",
        options: ["Very good", "Good", "Somewhat good", "Average", "Poor"],
      },
      {
        id: 64,
        question:
          "If I were a doctor and you were describing your medical history for me, what would it entail? (Accidents, hospitalizations, chronic ailments like asthma, conditions like diabetes/high blood pressure/ hypothyroidism, diseases of any kind including HIV/AIDS, syphilis, herpes, or others)",
      },
      {
        id: 65,
        question:
          "What has been your experience with alcohol or drugs in the past and at the present time?",
      },
      {
        id: 66,
        question: "Do you exercise?",
        options: ["Often", "Sometimes", "Rarely", "Never"],
      },
      {
        id: 67,
        question:
          "When you are sick, how do you want others to respond to you?",
      },
      {
        id: 68,
        question:
          "When a significant person in your life is sick, how do you respond?",
      },
      {
        id: 69,
        question:
          "Do you like animals? Which ones? Would you like to have any of these animals as a pet? If yes, why? If not, why?",
      },
      {
        id: 70,
        question: "Do you hate any animals? If so, which ones?",
      },
      {
        id: 71,
        question: "Are you sensitive to sounds and smells?",
      },
      {
        id: 72,
        question: "Do you have difficulties with hot and/or cold weather?",
      },
      {
        id: 73,
        question:
          "Do you have any specific fears? List them (For example: Fear of heights, Fear of water, Fear of reptiles, Fear of number 13, Fear of Superiors etc)",
      },
    ],
  },

  section3: {
    title: "Childhood",
    questions: [
      {
        id: 1,
        question:
          "What was your experience at home while growing up? (This could mean your parent/s, sibling/s and extended family).",
        options: [
          "Happy",
          "Generally happy",
          "Difficult",
          "Generally difficult",
          "Mixed",
          "Traumatic",
        ],
      },
      {
        id: 2,
        question:
          "What was your experience outside your home while growing up? (This could mean school friends, others friends, neighbours, teachers, other members of society and the type of society in which you lived).",
        options: [
          "Happy",
          "Generally happy",
          "Difficult",
          "Generally difficult",
          "Mixed",
          "Traumatic",
        ],
      },
      {
        id: 3,
        question:
          "How would you consider your overall childhood experience if questions 1 and 2 above were combined?",
        options: [
          "Happy",
          "Generally happy",
          "Difficult",
          "Generally difficult",
          "Mixed",
          "Traumatic",
        ],
      },
      {
        id: 4,
        question: "Who raised you up?",
        options: [
          "Both parents",
          "Mostly mother",
          "Only mother",
          "Mostly father",
          "Only father",
          "Mostly grandparent(s)",
          "Only grandparent(s)",
          "Others:",
        ],
      },
      {
        id: 5,
        question:
          "Did you spend some part of your childhood in boarding school? If yes, how many years?",
      },
      {
        id: 6,
        question:
          "Did you spend some part of your life in a regular college hostel or a Krishna conscious facility like Krishna House or BACE? Where was it and how many years did you spend there?",
      },
      {
        id: 7,
        question:
          "What are five adjectives (positive or negative) you would select to describe your relationship with your father?",
      },
      {
        id: 8,
        question:
          "What are five adjectives (positive or negative) you would select to describe your relationship with your mother?",
      },
      {
        id: 9,
        question: "Did your parents ever argue in front of you?",
        options: ["No", "Rarely", "Occasionally/Periodically", "Regularly"],
      },
      {
        id: 10,
        question:
          "In what way do you see this contributing/affecting your life today?",
      },
      {
        id: 11,
        question:
          "Do you consider your parents' marriage as a good role-model? If yes, why? If not, why?",
      },
      {
        id: 12,
        question:
          "What was your family's economic level like when you were growing up? In what way do you see this affecting your life today?",
      },
      {
        id: 13,
        question:
          "Describe how you were disciplined as a child. If you have children, how will your discipline be the same and how will it be different than what you experienced? What is your understanding of Srila Prabhupada's instructions on this subject?",
      },
      {
        id: 14,
        question:
          "What are three of the most vivid memories you can recall from birth to age 18? (It does not have to be Krishna Conscious memories.)",
      },
      {
        id: 15,
        question:
          "Do you have brothers and sisters? What is your relationship with them?",
      },
      {
        id: 16,
        question:
          "Please answer the following question with a simple “yes” or “no” without having to describe anything. Were you sexually abused as a child and/or did you experience any #metoo incidents when you grew up? Please specify which of the two it was or whether it was both? What do you think is its effect on your life now? What have you done to deal with it?",
      },
      {
        id: 17,
        question:
          "If your prospective spouse could talk to your parents, what would they say he/she needed to know about you?",
      },
      {
        id: 18,
        question:
          "What do you wish you could say to your mother and father that you've never said to them?",
      },
    ],
  },

  section4: {
    title: "Past Relationships with the Opposite Sex",
    questions: [
      {
        id: 1,
        question:
          "If you have had any relationships with the opposite sex in the past (either through marriage or as a boyfriend/girlfriend), what was your last relationship like?",
      },
      {
        id: 2,
        question:
          "What are three reasons you’re confident the relationship is over and you can move forward?",
      },
      {
        id: 3,
        question: "What would those in your prior relationships say about you?",
      },
      {
        id: 4,
        question:
          "What have you learned from them that will make you a better person for someone this time?",
      },
      {
        id: 5,
        question:
          "On a scale of 0 to 10, to what extent do you experience guilt or anguish over your previous relationships?",
        options: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      },
      {
        id: 6,
        question:
          "How might this guilt be affecting you in building a relationship with another individual?",
      },
      {
        id: 7,
        question:
          "How frequently do you have contact with your former partners, if any, and in what way?",
      },
      {
        id: 8,
        question: "What is the purpose of the contact?",
      },
      {
        id: 9,
        question: "What feelings do you experience on these occasions?",
      },
      {
        id: 10,
        question:
          "If your past partners (if you had any) were asked if you were honest and trustworthy, how would they answer?",
      },
      {
        id: 11,
        question:
          "[If you have been married before] How many times have you been married, including any annulments?",
      },
    ],
  },

  section5: {
    title: "Marriage Expectations",
    questions: [
      {
        id: 1,
        question: "What is your dream or fantasy of a “perfect marriage”?",
      },
      {
        id: 2,
        question:
          "What has been your source of information about marriage? Parents, elders, friends, classes, books, movies, television, Prabhupada’s teachings, Internet, others (please specify). List whichever combination of the above is applicable.",
      },
      {
        id: 3,
        question:
          "What do you believe are some of the important elements that make marriages work?",
      },
      {
        id: 4,
        question:
          "If you were to marry, what would you receive from marriage that you wouldn’t if you were to remain single?",
      },
      {
        id: 5,
        question:
          "It is commonly said that a Krishna Conscious marriage is an attempt to balance spiritual and material life. If you agree, explain. If you do not agree, explain.",
      },
      {
        id: 6,
        question: "What are Prabhupada’s instructions about the duties of: [A husband, A wife]",
      },
      {
        id: 7,
        question:
          "After you get married, ten years from now where would you like to be economically?",
      },
      {
        id: 8,
        question: "If you are a man, what are your views about your wife working:",
        options: [
          "Absolutely no",
          "Until we have a child",
          "In some emergency (short term)",
          "For financial stability (long term)",
          "According to the preference of my wife",
          "I want a working wife",
          "I prefer a wife who stays at home but if she has an education, she should not waste it. Therefore, she should work",
          "Others",
        ],
      },
      {
        id: 9,
        question: "If you are a woman, what are your views on working after marriage:",
        options: [
          "Absolutely no",
          "Until we have a child",
          "In some emergency (short term)",
          "For financial stability (long term)",
          "I want to work",
          "According to the preference of my husband",
          "I prefer staying at home but I don’t want to waste my education. Therefore, I will work",
          "Others",
        ],
      },
      {
        id: 10,
        question:
          "Reorder the following in terms of your priorities (High priority first): Service at the Temple, Preaching Duties, Duties towards spouse and household duties, taking care of children, taking care of elderly members of the family, Finances, Health, Service to Guru(s) and spiritual superiors, helping neighbours, hosting guests, charity, friends, relatives.",
      },
      {
        id: 11,
        question:
          "Do you feel you need to compromise or sacrifice anything to be a part of a marriage relationship?",
      },
      {
        id: 12,
        question:
          "What is your greatest fear or concern about being married? Has this been addressed? If yes, how has your understanding changed?",
      },
      {
        id: 13,
        question:
          "What is there in your life that you never want to change after marriage or that you would never be able to let go off?",
      },
      {
        id: 14,
        question:
          "What are the “must have”, “preferably have”, “preferably not have” and “must not have” qualities in a person you may want to spend the rest of your life with?",
      },
      {
        id: 15,
        question:
          "What are five reasons a person would want to spend the rest of their life with you as your spouse, and three reasons they would find difficult? Among the three, which would be the hardest adjustment?",
      },
      {
        id: 16,
        question:
          "If you spend a lot of time on the computer or cell phone, how would you adjust this to work in a marriage?",
      },
      {
        id: 17,
        question:
          "What is your idea about romantic love? What do you think is the importance of romantic love in a successful marriage?",
      },
      {
        id: 18,
        question:
          "In any relationship, what part of giving yourself do you struggle with? Would this apply if you get married?",
      },
      {
        id: 19,
        question: "What is your understanding about intimacy in marriage?",
      },
      {
        id: 20,
        question:
          "What are your views on marital sex only for the procreation of children in accordance with scriptural teachings (Bg 7.11)? Do you think you would be able to follow this standard?",
      },
      {
        id: 21,
        question: "What is your understanding about celibacy in marriage?",
      },
      {
        id: 22,
        question:
          "Do you think all dealings with your friends and/or others should be shared with your spouse even if friends and/or others request specific confidentiality from sharing with your spouse in regard to some dealings?",
      },
      {
        id: 23,
        question:
          "Would you be willing to share with your spouse, all your personal e-mail passwords, mobile phone passwords, passwords for other electronic devices and all passwords in general except those related to your office work?",
      },
      {
        id: 24,
        question:
          "What are the experiences in life you would want the person you married to have had?",
      },
      {
        id: 25,
        question:
          "What are the experiences in life you would NOT want the person you married to have had?",
      },
      {
        id: 26,
        question:
          "If something really bothered you about your spouse, how would you go about expressing it to him/her?",
      },
      {
        id: 27,
        question: "List the services in which you would like work alone",
      },
      {
        id: 28,
        question: "List the services in which you would like to work with your spouse.",
      },
      {
        id: 29,
        question:
          "Of all your activities, which ones you would not enjoy doing with your spouse although you may do it out of a sense of duty, obligation towards spouse etc.",
      },
      {
        id: 30,
        question:
          "What qualities do you see in your parents that you expect to see in your future spouse?",
      },
      {
        id: 31,
        question:
          "What qualities do you see in your parents that you don’t expect to see in your future spouse?",
      },
      {
        id: 32,
        question:
          "Would you mind leaving your present residence to live somewhere else after marriage?",
      },
      {
        id: 33,
        question: "For Women: Do you have experience in household work? If yes, do you find it difficult or do you enjoy it or do you have mixed feelings about it? If no, do you have an interest to learn or do you find it somewhat challenging?",
      },
      {
        id: 34,
        question: " For Women: On a scale of 0 – 10, rate your expertise in each of the following:[Cooking,Cleaning,Organising home]",
      },
      {
        id: 35,
        question: "For Men: On a scale of 0-10, rate your expertise in cooking",
      },
      {
        id: 36,
        question: "What do you think of the traditional marriage model—that the husband is the leader, caretaker and provider of the family’s needs, and the wife favourably cooperates with the husband and manages the household?",
      },
      {
        id: 37,
        question: "If you were to marry, in what way would you maintain a healthy “interdependence”? What would you depend upon each other for and what would you take personal responsibility for?",
      },
      {
        id: 38,
        question: "Who should have the ultimate decision-making authority in married life?",
        options: [
          "The person most affected in each situation",
          "Husband only",
          "Generally husband, but by consulting a senior grhastha couple when the wife can’t agree",
          "Everything by mutual agreement",
          "Generally by mutual agreement, but by consulting a senior grhastha couple when they can’t agree",
          "Generally by mutual agreement, but husband when they can't agree",
          "Generally by mutual agreement, but wife when they can't agree",
          "Wife only",
          "Generally wife, but by consulting a senior grhastha couple when the husband can’t agree",
          "Whoever is insistent on a particular issue"
        ]
      },
      
      {
        id: 39,
        question: "Do you think that the traditional position and role of women from her birth till her death including that depicted in the Bhagavatam is relevant in today’s times? If so, how? If not, why?",
      },
      {
        id: 40,
        question: "If your spouse were to tell you that he/she doesn’t want to do something, or if he/she doesn’t feel comfortable doing something you would like to do, how would you want to handle that?",
      },
      {
        id: 41,
        question: "If your spouse messed up in a decision, whether in business or just in general, how would you share your frustration about that decision with your spouse?",
      },
      {
        id: 42,
        question: "Do you believe your partner and you should be honest about everything in your relationship, or should some things be kept private?",
      },
      {
        id: 43,
        question: "Would you be open to seek and receive help from your spouse in some or all challenging areas of Krishna Consciousness in your life?  List those challenging areas you wish to receive help from your spouse and those that you do not wish to receive help from your spouse.",
      },
      {
        id: 44,
        question: "When you marry, do you want children? If so, how many? Are you open to adoption? What if you had stepchildren?",
      },
      {
        id: 45,
        question: "Do you like dealing with children and enjoy being around them?",
      },
      {
        id: 46,
        question: "What are Prabhupada’s instructions on parenthood? What training have you had to be a parent? ",
      },
      {
        id: 47,
        question: "Does your idea of education for your children entail that they should go to a school where all students and teachers are Prabhupada’s followers? What should be in the curriculum and what should not be in it? Would that curriculum be realistic for your children to live in today’s world? If yes, how? If not, what would you do about it?",
      },
      {
        id: 48,
        question: "Would you mind your children going to regular schools if you and your spouse were to train them at home, in Krishna Consciousness apart from their school hours? Or would you think that apart from your training, it is also necessary for them to have friends who are Krishna Conscious in school?",
      },
      {
        id: 49,
        question: "Do you envision home schooling your children? If yes, what would be its advantages and shortcomings? What challenges do you foresee in implementing a home schooling program? ",
      },
      {
        id: 50,
        question: "How much do you value “personal time” - time to yourself to reflect, study, or recreate after marriage? How important would this be to you if you were to have children?",
      },
      {
        id: 51,
        question: "How would you handle birthdays, special occasions, and so on, when it comes to your biological family and your spouse’s biological family? What does gift giving mean to you?",
      },
      {
        id: 52,
        question: "You were supposed to attend the Mayapur festival for 8 days as instructed by Srila Prabhupada and one of your friends/cousins is getting married in some other place at the same time. You cannot do both. What would you do? Why?",
      },
      {
        id: 53,
        question: "If you inherited a large sum of money, would you still want your partner in your life? Why?",
      },
      {
        id: 54,
        question: "What are your views about divorce? ",
        options: [
          "Divorce is strictly prohibited in Krishna Consciousness",
          "Divorce is permitted under some circumstances",
        ]
      },
      {
        id: 55,
        question: "How much do you think astrology influences the success or failure of a Krishna conscious marriage? ",
      },
      {
        id: 56,
        question: "What is the best book that you have read in ISKCON about marriages and/or what is the best seminar or best talk on this topic that you have heard? Where can it be found?",
      },
      {
        id: 57,
        question: "Most of the associates of Lord Chaitanya Mahaprabhu were grhasthas and empowered grhastha acaryas are also listed in our disciplic succession. Who among them inspire you the most, and why?",
      },
      {
        id: 58,
        question: "Who are the grhastha couples in ISKCON that you know who have growing, healthy marriages?",
      },
      {
        id: 59,
        question: "After you’re married, would you be open to seek ongoing Krishna conscious marriage advise from experienced grhasthas? Who would that be? If not, how do you plan to resolve issues?",
      },
      {
        id: 60,
        question: "Left to yourself, would you like to remain unmarried? If yes, what are the compelling factors due to which you have decided to get married? For example: parents, spiritual master, god brothers, god sisters etc.",
      },
      {
        id: 61,
        question: "In the light of the number of divorces today, if you were to marry, why would your marriage last and not end up in the divorce court?",
      },
    ]
  }    
};

export default questions;
